.section {
  padding: 88px 24px;
}

.dark {
  background: rgba(0, 0, 0, 0.22);
}

.inner {
  max-width: var(--max-width);
  margin: 0 auto;
}

.eyebrow {
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-gold);
}

.title {
  margin-bottom: 16px;
  font-size: clamp(28px, 4vw, 40px);
  font-weight: 700;
  line-height: 1.15;
  letter-spacing: -0.02em;
}

.subtitle {
  max-width: 640px;
  margin-bottom: 40px;
  font-size: 17px;
  color: var(--color-text-muted);
}

@media (max-width: 640px) {
  .section {
    padding: 64px 20px;
  }
}
